// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/engagement/campaign_data(/:campaign_id)" endpoint
 */
import type { FetchOptions } from "@lib/fetch";
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementCampaignDataCampaignId } from "./constants";
import type { EngagementCampaignDataResult } from "./types";

export const getEngagementCampaignDataCampaignId = reactQueryFetcherAdapter(
  engagementCampaignDataCampaignId,
  (
    signal: AbortSignal,
    campaignId: string,
    appGroupId: string,
    viewActiveCampaign: boolean,
    options: FetchOptions = {}
  ): Promise<EngagementCampaignDataResult> => {
    return fetch(
      `/engagement/campaign_data/${campaignId}`,
      "GET",
      { app_group_id: appGroupId, view_active_campaign: viewActiveCampaign },
      {
        ...options,
        signal,
      }
    );
  }
);
